<template>
  <div class="admin-drawer-container">
    <div
      :class="['drawer-overlay', { 'is-open': isMenuOpen }]"
      @click="toggleMenu"
    ></div>
    <button class="menu-toggle" @click="toggleMenu">
      <i class="fas fa-bars"></i>
    </button>
    <div :class="['side-drawer', { 'is-open': isMenuOpen }]">
      <div class="drawer-header">
        <i class="fas fa-user-shield"></i>
        <span>Admin Panel</span>
      </div>
      <nav class="drawer-nav">
        <a
          v-for="item in menuItems"
          :key="item.id"
          :class="['drawer-item', { active: activeMenu === item.id }]"
          @click="handleMenuClick(item.id)"
        >
          <i :class="item.icon"></i>
          <span>{{ item.label }}</span>
        </a>
      </nav>
      <div class="drawer-footer">
        <a class="drawer-item logout" @click="handleLogout">
          <i class="fas fa-sign-out-alt"></i>
          <span>Logout</span>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "AdminDrawer",
  props: {
    activeMenu: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      isMenuOpen: false,
      menuItems: [
        { id: "dashboard", label: "Dashboard", icon: "fas fa-chart-line" },
        { id: "clients", label: "Clients", icon: "fas fa-users" },
        {
          id: "investments",
          label: "Investments",
          icon: "fas fa-money-bill-wave",
        },
        { id: "reports", label: "Reports", icon: "fas fa-file-alt" },
        { id: "settings", label: "Settings", icon: "fas fa-cog" },
        {
          id: "provisioning",
          label: "Client Provisioning",
          icon: "fas fa-user-plus",
        },
      ],
    };
  },
  methods: {
    ...mapActions(["logout"]),
    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen;
      document.body.style.overflow = this.isMenuOpen ? "hidden" : "";
    },
    handleMenuClick(menuId) {
      if (menuId === this.activeMenu) return;

      switch (menuId) {
        case "dashboard":
          this.$router.push("/admin");
          break;
        case "clients":
          this.$router.push("/admin/clients");
          break;
        case "investments":
          this.$router.push("/admin/investments");
          break;
        case "reports":
          this.$router.push("/admin/reports");
          break;
        case "settings":
          this.$router.push("/admin/settings");
          break;
        case "provisioning":
          this.$router.push("/admin/provisioning");
          break;
      }

      // Close menu on mobile after navigation
      if (window.innerWidth <= 768) {
        this.isMenuOpen = false;
      }
    },
    async handleLogout() {
      try {
        // Configuration from aws-config.js
        const clientId = "2g84dlu4d6uqsigg1pvfcojnuj";
        const domain =
          "riddhi-preprod-ap-south-1-349100327741.auth.ap-south-1.amazoncognito.com";
        const redirectUri = encodeURIComponent(window.location.origin);

        // Clear local auth state first
        await this.logout();

        // Redirect to Cognito logout URL
        window.location.href = `https://${domain}/logout?client_id=${clientId}&logout_uri=${redirectUri}`;
      } catch (error) {
        console.error("Error signing out:", error);
      }
    },
  },
  // Clean up when component is destroyed
  beforeUnmount() {
    document.body.style.overflow = "";
  },
};
</script>

<style scoped>
.admin-drawer-container {
  position: relative;
  height: 100%;
}

.side-drawer {
  width: 260px;
  background: #2c3e50;
  color: white;
  display: flex;
  flex-direction: column;
  height: 100vh; /* Full viewport height */
  position: sticky;
  top: 0;
  box-shadow: 2px 0 10px rgba(0, 0, 0, 0.1);
}

.drawer-header {
  padding: 1.5rem;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  display: flex;
  align-items: center;
  gap: 1rem;
  font-size: 1.2rem;
  font-weight: 600;
  background-color: #1a2530;
}

.drawer-header i {
  font-size: 1.4rem;
  color: #3498db;
}

.drawer-nav {
  flex: 1;
  padding: 1rem 0;
  overflow-y: auto;
}

.drawer-item {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 1rem 1.5rem;
  color: rgba(255, 255, 255, 0.8);
  text-decoration: none;
  cursor: pointer;
  transition: all 0.3s;
  border-left: 3px solid transparent;
}

.drawer-item:hover {
  background: rgba(255, 255, 255, 0.1);
  color: white;
  border-left-color: #3498db;
}

.drawer-item.active {
  background: rgba(255, 255, 255, 0.1);
  color: white;
  border-left: 3px solid #3498db;
}

.drawer-item i {
  width: 20px;
  text-align: center;
}

.drawer-footer {
  padding: 1rem 0;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
}

.drawer-item.logout {
  color: #e74c3c;
}

.drawer-item.logout:hover {
  background: rgba(231, 76, 60, 0.1);
  border-left-color: #e74c3c;
}

.menu-toggle {
  display: none;
  align-items: center;
  justify-content: center;
  position: fixed;
  top: 1rem;
  left: 1rem;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: #3498db;
  color: white;
  border: none;
  cursor: pointer;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
  z-index: 101;
}

.drawer-overlay {
  display: none;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 99;
}

@media (max-width: 768px) {
  .side-drawer {
    position: fixed;
    left: -260px;
    top: 0;
    bottom: 0;
    z-index: 100;
    transition: left 0.3s ease-in-out;
    height: 100%; /* Full height on mobile */
  }

  .side-drawer.is-open {
    left: 0;
  }

  .drawer-overlay {
    display: block;
    opacity: 0;
    visibility: hidden;
    transition: opacity 0.3s ease-in-out, visibility 0.3s ease-in-out;
  }

  .drawer-overlay.is-open {
    opacity: 1;
    visibility: visible;
  }

  .menu-toggle {
    display: flex;
  }
}
</style>
